import { useState, useLayoutEffect, type RefObject } from "react";

export const useFullbleed = (containerRef: RefObject<HTMLElement>) => {
  const [bleed, setBleed] = useState(0);

  useLayoutEffect(() => {
    const el = containerRef.current;
    if (!el) {
      return;
    }

    let rafId: number;

    const updateBleed = () => {
      const rect = el.getBoundingClientRect();
      // rect.left is the distance from the viewport edge to the container
      setBleed(rect.left);
    };

    const handleUpdate = () => {
      cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(updateBleed);
    };

    const observer = new ResizeObserver(handleUpdate);
    observer.observe(el);

    window.addEventListener("resize", handleUpdate, { passive: true });

    // Initial update
    updateBleed();

    return () => {
      observer.disconnect();
      window.removeEventListener("resize", handleUpdate);
      cancelAnimationFrame(rafId);
    };
  }, [containerRef]);

  return bleed;
};
